import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class TextAreaField extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {}
    this.onChange = this.onChange.bind(this)
    this.input = React.createRef()
  }
  onChange () {
    let { value } = this.input.current
    this.props.onChange(value)
  }
  render () {
    const { invalid, isRequired, noTab, title, value, disabled } = this.props
    return (
      <div className={`form-row form-row-long ${disabled ? 'disabled' : ''}`}>
        <div className='row-title'>
          <p
            className={`row-text ${invalid ? 'row-text-invalid' : ''}`}>
            {title}{isRequired ? <span className='asterisk'>*</span> : ''}:
          </p>
        </div>
        <div className='row-content'>
          <textarea
            ref={this.input}
            className='textarea'
            value={value}
            onChange={this.onChange}
            {...noTab ? { tabIndex: -1 } : {}}
          />
        </div>
      </div>
    )
  }
}

TextAreaField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  invalid: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  noTab: PropTypes.bool.isRequired
}

TextAreaField.defaultProps = {
  invalid: false,
  noTab: false
}

export default TextAreaField
